import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import NewTopNavBar from "./NewTopNavBar";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
const JiraIntegration = () => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalItems, setTotalItems] = useState(0);
    const [start, setStart] = useState(0); // Start from 1
    const [limit, setLimit] = useState(10); // Set default limit to 5
    const [currentPage, setCurrentPage] = useState(1); // Track the current page
    const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const [initialLoader, setInitialLoader] = useState(true);
    const [selectedOptionDate, setSelectedOptionDate] = useState('1-day');
    const [loadingInfiniteScroll, setLoadingInfiniteScroll] = useState(true);
    const sentinelRef = useRef(null);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const validStatuses = ["open", "resolved", "in progress", "closed"]; // List of valid Jira statuses
    const options = [
        { id: "select", label: "Select" },
        { id: "default", label: "Default Search" },
        { id: "date", label: "Date Duration Search" },
        { id: "username", label: "User Name Search" },
    ];
    const optionsDate = [
        { id: "1-day", label: "24 hrs Data" },
        { id: "1-week", label: "1 Week Older" },
        { id: "1-month", label: "1 Month Older" },
        { id: "3-months", label: "3 Months Older" },
        { id: "custom", label: "Custom" },
    ];

    //   const [selectedOption, setSelectedOption] = useState(options[0].id);
    const [selectedOption, setSelectedOption] = useState("default");

    const handleChange = (event) => {
        console.log(event.target.value);
        // setSelectedOption(event.target.value);
        setSelectedOption("default");
        console.log(event.target.value);
        setSelectedOptionDate(event.target.value);
        setSearchTerm("");
        setDateStart("");
        setDateEnd("");
        setTableData([])
        setLoading(true)
        setCurrentPage(1)
        // setSelectedOption(parseInt(event.target.value, 10));
    };
    const isNumberValid = (input) => {
        const numberRegex = /^-?\d+(\.\d+)?$/;
        return numberRegex.test(input);
    };
    // Fetch data from the API per page
    const fetchData = async (start, limit, searchTerm = "") => {

        // setLoading(true);
        try {
            // const jqlQuery = ` AND (summary ~ "${searchTerm}" OR description ~ "${searchTerm}" OR status = "${searchTerm}")`;

            //

            const statusQuery = validStatuses.includes(searchTerm.toLocaleLowerCase())
                ? `status = "${searchTerm}"`
                : ""; // If not a valid status, leave the status query empty
            // id = "${searchTerm}" OR
            // Build the JQL query
            const isInteger = /^\d+$/.test(searchTerm);
            let jqlQuery = "project=10001";
            if (selectedOption == "default" && statusQuery != "") {
                jqlQuery = `project=10001 AND (${isInteger ? `id = ${searchTerm}` : ""
                    }${isInteger ? " OR " : ""
                    }summary ~ "${searchTerm}" OR description ~ "${searchTerm}"${statusQuery ? ` OR ${statusQuery} OR reporter=${searchTerm}` : ""
                    })`;
            } else if (selectedOption == "username" && statusQuery != "") {
                jqlQuery = `project=10001 AND reporter=${searchTerm}`;
            } else if (selectedOption == "date") {
                setTableData([])
                setLoading(true)
                jqlQuery = `created>=${dateStart} AND created<=${dateEnd}`;
            }
            if (
                selectedOptionDate == "1-day" ||
                selectedOptionDate == "1-week" ||
                selectedOptionDate == "1-month" ||
                selectedOptionDate == "3-months" ||
                selectedOptionDate == "custom"
            ) {
                // setLoading(true)
                // setTableData([])
                // alert(currentPage - 2)

                const today = new Date(); // Current date
                let comparisonDate;
                // const today = new Date();
                const formatDate = (date) => {
                    return date.toISOString().split("T")[0]; // Converts to 'YYYY-MM-DD'
                };
                let currentDate = formatDate(new Date(today));

                if (selectedOptionDate === "1-week") {
                    comparisonDate = new Date(today);
                    console.log("Current Date:", formatDate(comparisonDate)); // Log the current date



                    comparisonDate.setDate(today.getDate() - 7); // 1 week ago

                    jqlQuery = `created>=${formatDate(
                        comparisonDate
                    )} AND created<=${currentDate}`;
                } else if (selectedOptionDate == "1-day") {
                    // alert("if")
                    comparisonDate = new Date(today);
                    console.log("Current Date:", formatDate(comparisonDate)); // Log the current date

                    comparisonDate.setDate(today.getDate() - 1); // 1 week ago

                    jqlQuery = `created>=${formatDate(
                        comparisonDate
                    )} AND created<=${currentDate}`;
                }
                else if (selectedOptionDate === "1-month") {
                    comparisonDate = new Date(today);
                    comparisonDate.setMonth(today.getMonth() - 1); // 1 month ago
                    console.log("1 Month Older Date:", formatDate(comparisonDate));
                    jqlQuery = `created>=${formatDate(
                        comparisonDate
                    )} AND created<=${currentDate}`;
                } else if (selectedOptionDate === "3-months") {
                    comparisonDate = new Date(today);
                    comparisonDate.setMonth(today.getMonth() - 3); // 3 months ago
                    console.log("3 Months Older Date:", formatDate(comparisonDate));
                    jqlQuery = `created>=${formatDate(
                        comparisonDate
                    )} AND created<=${currentDate}`;
                } else if (selectedOptionDate == "custom") {
                    // alert('custom')
                    jqlQuery = `created>=${dateStart} AND created<=${dateEnd}`;
                }
            }
            //

            const result = await axios.get(
                `https://kr.camptratech.com/krproxy/https://silfratech2.atlassian.net/rest/api/2/search`,
                {
                    params: {
                        jql: jqlQuery,
                        // startAt: start,
                        startAt: currentPage - 2,
                        maxResults: limit,
                    },
                    auth: {
                        username: "diya@silfratech.com",
                        password:
                            "ATATT3xFfGF0NTR3_KZOT08HeahZDyCj4ZPRxAloPha1i2CbX4GSfjDqi5bufgP_zGCBMBWNXbAqdluNGUpKZo60CjPKgzoYd62ZUiWHHobf2tLWdjDycvedZZs5JcfyTbCPL5Qp_acCu3o5xpELD4xVDMa2XM56P5n1z53n08fWkkliROO6sOs=1818D2DC",
                    },
                }
            );
            console.log("line33=", result.data.issues);
            const updatedData = await Promise.all(
                result?.data?.issues?.map(async (issue) => {
                    console.log(issue.fields.reporter.displayName);
                    const displayName = issue.fields.reporter.displayName;
                    console.log(displayName.includes("gmail"));
                    // Check if the display name contains "gmail"
                    if (emailRegex.test(displayName)) {
                        console.log("if=", displayName);
                        try {
                            // Fetch username from the second API
                            const response = await axios.get(
                                `https://aichat.silfratech.in/backend2/v1/user/get-username`,
                                {
                                    params: {
                                        email: displayName, // Assuming emailAddress exists in the issue fields
                                    },
                                }
                            );

                            // Update the displayName with the fetched username
                            issue.fields.reporter.displayName = response.data.username;
                        } catch (error) {
                            console.error("Error fetching username from API:", error);
                        }
                    }

                    return issue;
                })
            );
            setInitialLoader(false);

            // setTableData(updatedData); // Store data in tableData
            setTotalItems(result.data.total - 1); // Store total item count for pagination
            // infinite scroll
            console.log("filterData=", updatedData);
            // setAllCategory(filterCatData);
            setTableData((prevPosts) => [...prevPosts, ...updatedData]);
            // setSpnierLoading(false);
            // if (res.length < 7) {
            //   setLoading(false);
            // }
            if (updatedData.length == 0 || updatedData.length < 7) {
                console.log("dfddgdfdg");
                setLoading(false);
                // setLoadingInfiniteScroll(false)
            }
            // infinite scroll
        } catch (error) {
            console.error("Error fetching data", error);
        }
        setLoading(false);
    };

    const searchData = async (start, limit, searchTerm = "") => {
        // setTotalItems(0)
        // setTableData([])
        // alert('dsfd')
        console.log({ selectedOption });
        console.log({ dateStart }, { dateEnd });

        const startDate = new Date(dateStart);
        const endDate = new Date(dateEnd);
        // alert(startDate >= endDate);
        if (startDate >= endDate) {
            toast.error(
                "Invalid dates: 'Start Date' cannot be grater than 'End Date'."
            );
            return;
        }

        setLoading(true);
        //  OR status = "${searchTerm}")
        try {
            // const jqlQuery = `project=10001 AND (summary ~ "${searchTerm}" OR description ~ "${searchTerm}")`;
            const statusQuery = validStatuses.includes(searchTerm.toLocaleLowerCase())
                ? `status = "${searchTerm}"`
                : ""; // If not a valid status, leave the status query empty
            // id = "${searchTerm}" OR
            // Build the JQL query

            const isInteger = /^\d+$/.test(searchTerm);
            let jqlQuery = "";
            if (selectedOption == "default") {
                jqlQuery = `project=10001 AND (${isInteger ? `id = ${searchTerm}` : ""
                    }${isInteger ? " OR " : ""
                    }summary ~ "${searchTerm}" OR description ~ "${searchTerm}" OR reporter=${searchTerm}${statusQuery ? ` OR ${statusQuery} ` : ""
                    })`;
            } else if (selectedOption == "username") {
                jqlQuery = `project=10001 AND reporter=${searchTerm}`;
            } else if (selectedOption == "date") {
                jqlQuery = `created>=${dateStart} AND created<=${dateEnd}`;
            }
            console.log({ jqlQuery });
            const result = await axios.get(
                `https://kr.camptratech.com/krproxy/https://silfratech2.atlassian.net/rest/api/2/search`,
                {
                    params: {
                        jql: jqlQuery,
                        // startAt: start,
                        startAt: currentPage - 2,
                        maxResults: limit,
                    },
                    auth: {
                        username: "diya@silfratech.com",
                        password:
                            "ATATT3xFfGF0NTR3_KZOT08HeahZDyCj4ZPRxAloPha1i2CbX4GSfjDqi5bufgP_zGCBMBWNXbAqdluNGUpKZo60CjPKgzoYd62ZUiWHHobf2tLWdjDycvedZZs5JcfyTbCPL5Qp_acCu3o5xpELD4xVDMa2XM56P5n1z53n08fWkkliROO6sOs=1818D2DC",
                    },
                }
            );
            console.log("line33=", result.data.issues);
            const updatedData = await Promise.all(
                result?.data?.issues?.map(async (issue) => {
                    console.log(issue.fields.reporter.displayName);
                    const displayName = issue.fields.reporter.displayName;
                    console.log(displayName.includes("gmail"));
                    // Check if the display name contains "gmail"
                    if (emailRegex.test(displayName)) {
                        console.log("if=", displayName);
                        try {
                            // Fetch username from the second API
                            const response = await axios.get(
                                `https://aichat.silfratech.in/backend2/v1/user/get-username`,
                                {
                                    params: {
                                        email: displayName, // Assuming emailAddress exists in the issue fields
                                    },
                                }
                            );

                            // Update the displayName with the fetched username
                            issue.fields.reporter.displayName = response.data.username;
                        } catch (error) {
                            console.error("Error fetching username from API:", error);
                        }
                    }

                    return issue;
                })
            );

            // setTableData(updatedData); // Store data in tableData
            // setTotalItems(result.data.total - 1); // Store total item count for pagination

            // 
            setInitialLoader(false);

            // setTableData(updatedData); // Store data in tableData
            setTotalItems(result.data.total - 1); // Store total item count for pagination
            // infinite scroll
            console.log("filterData=", updatedData);
            // setAllCategory(filterCatData);
            setTableData((prevPosts) => [...prevPosts, ...updatedData]);
            // setSpnierLoading(false);
            // if (res.length < 7) {
            //   setLoading(false);
            // }
            if (updatedData.length == 0 || updatedData.length < 7) {
                console.log("dfddgdfdg");
                setLoading(false);
                // setLoadingInfiniteScroll(false)
            }

            // 

        } catch (error) {
            console.error("Error fetching data", error);
        }
        setLoading(false);
    };
    // if (searchTerm == "") {
    //   fetchData(start, limit, searchTerm);
    // }
    useEffect(() => {
        // if (searchTerm == "") {
        //   fetchData(start, limit, searchTerm);
        // } // Fetch data based on start, limit, and search term
        // else {
        //   searchData(start, limit, searchTerm);
        // }

        const delayDebounceFn = setTimeout(() => {
            // alert(searchTerm)
            console.log({ searchTerm })
            if (searchTerm.trim() !== "") {
                // setTableData([])
                // console.log('if')
                searchData(start, limit, searchTerm);

            } else {
                // alert('else')
                fetchData(start, limit, searchTerm);
            }
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [start, limit, searchTerm, selectedOptionDate, loadingInfiniteScroll, currentPage]);

    //

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setCurrentPage((prevPage) => prevPage + 1);
                    }
                });
            },
            { threshold: 1 }
        );

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [loading]);

    // 

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",

                disableSortBy: false,
                Cell: ({ value }) => (
                    <a
                        target="_blank"
                        href={`https://silfratech2.atlassian.net/rest/api/2/issue/${value}`}
                        style={{ textDecoration: "none", color: "#007bff" }}
                    >
                        {value}
                    </a>
                ),
            },
            {
                Header: "Date Created",
                accessor: "fields.created",
                Cell: ({ value }) => {
                    const date = new Date(value);
                    const formattedDate = date.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    });
                    const formattedTime = date.toLocaleTimeString("en-GB", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                    });
                    return `${formattedDate}, ${formattedTime}`;
                },
            },
            {
                Header: "User Name",
                accessor: "fields.reporter.displayName",
                disableSortBy: false,
            },
            {
                Header: "Description",
                accessor: "fields.summary",
                disableSortBy: true,
                Cell: ({ value }) =>
                    value.length > 90 ? `${value.slice(0, 90)}...` : value,
            },
            {
                Header: " Status",
                accessor: "fields.status.name",
                disableSortBy: false,
            },
            {
                Header: "Date Updated",
                accessor: "fields.updated",
                Cell: ({ value }) => {
                    const date = new Date(value);
                    const formattedDate = date.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    });
                    const formattedTime = date.toLocaleTimeString("en-GB", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                    });
                    return `${formattedDate}, ${formattedTime}`;
                },
                disableSortBy: false,
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        setPageSize: tableSetPageSize,
        state: { pageSize: currentPageSize },
    } = useTable(
        {
            columns,
            data: tableData,
            manualPagination: true, // Manually handle pagination
            pageCount: Math.ceil(totalItems / limit),
        },
        useSortBy,
        usePagination
    );

    const handlePageSizeChange = (e) => {
        const newPageSize = Number(e.target.value);
        setLimit(newPageSize); // Update limit instead of pageSize
        tableSetPageSize(newPageSize);
        setStart(1); // Reset start when page size changes
        setCurrentPage(1); // Reset to first page
    };

    const handleNextPage = () => {
        if (currentPage * limit < totalItems) {
            const newStart = start + limit;
            setStart(newStart); // Increment start by limit
            setCurrentPage(currentPage + 1); // Go to the next page
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newStart = start - limit;
            setStart(newStart); // Decrement start by limit
            setCurrentPage(currentPage - 1); // Go to the previous page
        }
    };

    // Handle page number click
    const handlePageClick = (pageNumber) => {
        const newStart = (pageNumber - 1) * limit;
        setStart(newStart);
        setCurrentPage(pageNumber);
    };

    // Render page numbers
    const totalPages = Math.ceil(totalItems / limit);
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    // Function to get a subset of page numbers for display
    const getVisiblePages = (currentPage, totalPages) => {
        const visiblePages = [];
        const maxVisibleButtons = 5; // Maximum number of buttons to display at a time

        if (totalPages <= maxVisibleButtons) {
            // Show all pages if they are fewer than maxVisibleButtons
            for (let i = 1; i <= totalPages; i++) {
                visiblePages.push(i);
            }
        } else {
            if (currentPage <= 5) {
                // Show first few pages with ellipses at the end
                // visiblePages.push(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "end-ellipsis");
                visiblePages.push(1, 2, 3, 4, 5, 6, "end-ellipsis");
            } else if (currentPage > totalPages - 5) {
                // alert("dfgdfg")
                // Show last few pages with ellipses at the start
                // visiblePages.push("start-ellipsis", totalPages - 9, totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
                visiblePages.push(
                    "start-ellipsis",
                    totalPages - 5,
                    totalPages - 4,
                    totalPages - 3,
                    totalPages - 2,
                    totalPages - 1,
                    totalPages
                );
            } else {
                // alert("e")
                // Show pages around the current page with ellipses on both sides
                visiblePages.push(
                    "start-ellipsis",
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    currentPage + 2,
                    currentPage + 3,
                    currentPage + 4,
                    currentPage + 5,
                    // currentPage + 6,
                    // currentPage + 7,
                    // currentPage + 8,
                    // currentPage + 9,
                    // currentPage + 10,
                    "end-ellipsis"
                );
            }
        }

        console.log({ visiblePages });

        return visiblePages;
    };

    const visiblePages = getVisiblePages(currentPage, totalPages);
    //
    const handleSearch = (e) => {
        e.preventDefault();
        setStart(0); // Reset to the first page
        searchData(0, limit, searchTerm);
        setCurrentPage(1);
    };
    console.log({ loading })
    return (
        <div className="">
            {/* <div className="header bg-dark">
                <div className="px-3 py-2">
                    <img
                        src="https://silfratech.com/wp-content/uploads/2016/06/silfra-logo-150-e1600848356342.png"
                        alt=""
                    />
                </div>
            </div> */}
            <NewTopNavBar />
            <div className="p-4 px-5">
                <h2 style={{ fontWeight: "bold" }} className="text-center fw-bold">
                    My Tickets
                </h2>
                {/* Search Form */}
                {!initialLoader ? (
                    <div className="">
                        <div className="d-flex justify-content-between px-5 pb-2">
                            <div className="py-4 ">
                                <select
                                    id="categorySelect"
                                    className="d-none"
                                    value={currentPageSize}
                                    onChange={handlePageSizeChange}
                                    style={{}}
                                >
                                    {[10, 20, 30].map((size) => (
                                        <option key={size} value={size}>
                                            Show {size}
                                        </option>
                                    ))}
                                </select>
                                <span style={{ marginLeft: "20px" }}>
                                    {/* Showing items {start + 1} to {Math.min(start + limit)} of{" "}
                                    {totalItems + 1} */}
                                    Showing items {limit * currentPage} of{" "}
                                    {totalItems + 1}
                                </span>
                            </div>
                            <div className="d-none">
                                <label className="pe-2" htmlFor="dropdown">
                                    Select an option:
                                </label>
                                <select
                                    id="categorySelect"
                                    value={selectedOption}
                                    onChange={handleChange}
                                >
                                    {options.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <select
                                    id="categorySelect"
                                    value={selectedOptionDate}
                                    onChange={handleChange}
                                    placeholder="Select Age Range"
                                >
                                    {optionsDate.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                {selectedOptionDate === "custom" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <label className="pe-2" htmlFor="dateStart">
                                            Start Date:
                                        </label>
                                        <input

                                            className=""
                                            value={dateStart}
                                            type="date"
                                            id="categorySelect"
                                            onChange={(e) => setDateStart(e.target.value)}
                                        />
                                        <label className="px-2" htmlFor="dateEnd">
                                            End Date:
                                        </label>
                                        <input
                                            value={dateEnd}
                                            type="date"
                                            id="categorySelect"
                                            onChange={(e) => setDateEnd(e.target.value)}
                                        />
                                        <Button
                                            className="ms-2"
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                            </div>
                            <div className="">
                                {selectedOption === "default" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <input
                                            type="text "
                                            className="form-control me-1"
                                            // by summary, description, or status
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <Button
                                            className=""
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                                {selectedOption === "username" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <input
                                            type="text "
                                            className="form-control me-1"
                                            // by summary, description, or status
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <Button
                                            className=""
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                                {selectedOption === "date" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <label className="pe-2" htmlFor="dateStart">
                                            Start Date:
                                        </label>
                                        <input
                                            className=""
                                            value={dateStart}
                                            type="date"
                                            id="dateStart"
                                            onChange={(e) => setDateStart(e.target.value)}
                                        />
                                        <label className="px-2" htmlFor="dateEnd">
                                            End Date:
                                        </label>
                                        <input
                                            value={dateEnd}
                                            type="date"
                                            id="dateEnd"
                                            onChange={(e) => setDateEnd(e.target.value)}
                                        />
                                        <Button
                                            className="ms-2"
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                            </div>
                        </div>
                        <div className="px-5">
                            <table
                                {...getTableProps()}
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    border: "1px solid #ddd",
                                    textAlign: "center",
                                }}
                            >
                                <thead>
                                    {headerGroups.map((headerGroup) => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <th
                                                    {...column.getHeaderProps(
                                                        column.getSortByToggleProps()
                                                    )}
                                                    style={{
                                                        padding: "10px",
                                                        borderBottom: "2px solid #ddd",
                                                        borderRight: "2px solid #ddd",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {column.render("Header")}
                                                    <span>
                                                        {column.isSorted
                                                            ? column.isSortedDesc
                                                                ? " 🔽"
                                                                : " 🔼"
                                                            : ""}
                                                    </span>
                                                </th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>
                                {/* {tableData} */}
                                {tableData.length > 0 ? (
                                    <tbody {...getTableBodyProps()}>
                                        {loading ? (
                                            <tr>
                                                <td
                                                    colSpan="6"
                                                    style={{ textAlign: "center", height: "50vh" }}
                                                >
                                                    <Spinner animation="border" />
                                                </td>
                                            </tr>
                                        ) : (
                                            page.map((row) => {
                                                prepareRow(row);
                                                return (
                                                    <tr {...row.getRowProps()}>
                                                        {row.cells.map((cell) => (
                                                            <td
                                                                {...cell.getCellProps()}
                                                                style={{
                                                                    padding: "10px",
                                                                    borderBottom: "1px solid #ddd",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {cell.render("Cell")}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                ) : !loading ? (
                                    <h5 colSpan="6"
                                        style={{ textAlign: "center" }} className="text-center py-3">No Data Found</h5>
                                ) : <tr colSpan="8"
                                    style={{ textAlign: "center" }} className="d-flex justify-content-center mb-5">
                                    {/* console.log("line205") */}
                                    {/* <Spinner /> */}

                                    <h4 className="pt-2">Loading...</h4>
                                </tr>}
                            </table>
                        </div>

                        {/* Pagination Controls */}
                        {/* <div style={{ marginTop: "20px", textAlign: "center" }}>
                        <Button
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                            style={{ marginRight: "10px", padding: "5px 10px" }}
                        >
                            Previous
                        </Button>
                        {pageNumbers.map((number) => (
                            <Button
                                key={number}
                                onClick={() => handlePageClick(number)}
                                style={{
                                    padding: "2px 10px",
                                    width: '40px',
                                    margin: "0 5px",
                                    backgroundColor: number === currentPage ? "#007bff" : "#fff",
                                    color: number === currentPage ? "#fff" : "#000",
                                }}
                            >
                                {number}
                            </Button>
                        ))}
                        <Button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                            style={{ marginLeft: "10px", padding: "5px 10px" }}
                        >
                            Next
                        </Button>
                    </div> */}
                        <div
                            className="px-5 d-none"
                            style={{ marginTop: "20px", textAlign: "center" }}
                        >
                            <Button
                                onClick={handlePreviousPage}
                                disabled={currentPage === 1}
                                style={{ marginRight: "10px", padding: "5px 10px" }}
                            >
                                Prev
                            </Button>
                            {visiblePages.map((number, index) =>
                                number === "start-ellipsis" || number === "end-ellipsis" ? (
                                    <span
                                        key={number + index} // Unique key for ellipses
                                        style={{
                                            margin: "0 5px",
                                            color: "#888",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        ...
                                    </span>
                                ) : (
                                    <Button
                                        key={number}
                                        onClick={() => handlePageClick(number)}
                                        style={{
                                            padding: "2px 10px",
                                            width: "40px",
                                            margin: "0 5px",
                                            backgroundColor:
                                                number === currentPage ? "#007bff" : "#fff",
                                            color: number === currentPage ? "#fff" : "#000",
                                        }}
                                    >
                                        {number}
                                    </Button>
                                )
                            )}
                            <Button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                                style={{ marginLeft: "10px", padding: "5px 10px" }}
                            >
                                Next
                            </Button>
                        </div>

                    </div>
                ) : (
                    <div className="text-center pt-5">
                        <Spinner />
                    </div>
                )}
                <div>

                    {loading && tableData?.length > 0 ? (
                        <div className="d-flex justify-content-center mb-5">
                            {/* console.log("line205") */}
                            <Spinner />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
            {/*  */}
            <div ref={sentinelRef} />
            {loadingInfiniteScroll && tableData?.length > 0 ? (
                <div className="d-flex justify-content-center mb-5">

                    <Spinner />
                </div>
            ) : (
                ""
            )}
            {/* </div> */}

            {/*  */}
        </div >
    );
};

export default JiraIntegration;
